import { DEFAULT_THEME, normalizeTheme, THEME_STORAGE_KEY } from './archonTheme';

/** @returns {import('./archonTheme').ArchonThemeId} */
export function getStoredTheme() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    return normalizeTheme(raw);
  } catch {
    return DEFAULT_THEME;
  }
}

/** @param {import('./archonTheme').ArchonThemeId} theme */
export function setStoredTheme(theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, normalizeTheme(theme));
  } catch {
    /* ignore quota / private mode */
  }
}
